/* tslint:disable */
/* eslint-disable */
/**
 * Intee
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PostType {
    Demand = 'Demand',
    Offer = 'Offer'
}

export function PostTypeFromJSON(json: any): PostType {
    return PostTypeFromJSONTyped(json, false);
}

export function PostTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostType {
    return json as PostType;
}

export function PostTypeToJSON(value?: PostType | null): any {
    return value as any;
}

